// extracted by mini-css-extract-plugin
module.exports = {"processTitle":"processTitle[Frida]3kMbiY-T","filter":"filter[Frida]1O-ldjAo","pagination":"pagination[Frida]3ocvjKI0"};